/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Spending_Cap_Set_ButtonInputs */



/**
* | output |
* | --- |
* | "Set spending cap" |
*
* @param {Gateway_Spending_Cap_Set_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_spending_cap_set_button = /** @type {((inputs?: Gateway_Spending_Cap_Set_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Spending_Cap_Set_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabenlimit setzen")
	return /** @type {LocalizedString} */ ("Set spending cap")
});